import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import NewCustomerButton from '../../dashboard/NewCustomerButton';
import SearchContext from '../../../context/search-context';
import styles from './CustomerSearchResultTable.module.css';
import Customer from '../../../models/Customer';
import CustomerSearch from '../CustomerSearch/CustomerSearch';
import CustomerContext from '../../../context/customer-context';

function CustomerSearchResultTable() {
  const searchCtx = useContext(SearchContext);
  const customerCtx = useContext(CustomerContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const openCustomerDashboard = (customer: Customer) => {
    customerCtx.setCustomer(customer);
    navigate('/customer');
  };

  return (
   <>
    <div className={styles.customerActions}>
        <div className={styles.pageTitle}>
              {t('pages.dashboard')}
        </div>
        <div className={styles.newCustomer}>
              <NewCustomerButton />
        </div> 
    </div>
    <div className={styles.container}>
      <div className={styles.searchBar}>
        <CustomerSearch />
      </div>
      <p className={styles.searchResult}>
        {t('header.search.searchResult', { numberOfCustomers: searchCtx.searchResult.length })}
      </p>
      {searchCtx.showNotification &&
        <p className={styles.notification}>{t('header.search.tooManyClients')}</p>}
      {searchCtx.searchResult.length > 0 && (
        <table className={styles.table}>
          <thead>
          <tr className={styles.row}>
            <th>{t('header.search.tableHeadings.client')}</th>
            <th>{t('header.search.tableHeadings.id')}</th>
            <th>{t('header.search.tableHeadings.cif')}</th>
            <th>{t('header.search.tableHeadings.login')}</th>
            <th>{t('header.search.tableHeadings.status')}</th>
          </tr>
          </thead>
          <tbody>
          {searchCtx.searchResult.map(customer =>
            <tr key={customer.id} className={styles.row}>
              <td>
              <span
                role='button'
                tabIndex={0}
                className={styles.name}
                onClick={() => openCustomerDashboard(customer)}
                onKeyDown={() => openCustomerDashboard(customer)}
              >
                {customer.firstName}
                {' '}
                {customer.name}
              </span>
              </td>
              <td>{customer.registrationCode}</td>
              <td>{customer.cif}</td>
              <td>{customer.loginName}</td>
              <td>{customer.customerStatus}</td>
            </tr>,
          )}
          </tbody>
        </table>
      )}
    </div>
   </>
  );
}

export default CustomerSearchResultTable;
